import { get, post } from '../BaseApi'
import { UserSettings } from './index'

export function login(username: string, password: string, cb = (_?: Error) => {}): Promise<any> {
  return post('/komatsu-login', { username, password }, cb, {})
}

export function windowsLogin(cb = (_?: Error) => {}): Promise<any> {
  return get('/sso-login', null, cb)
}

export function getProfile(cb = (_?: Error) => {}): Promise<any> {
  return get('/me', null, cb)
}

export function logout(cb = (_?: Error) => {}): Promise<any> {
  return post('/logout', null, cb)
}

export function updateSettings(settings: UserSettings, cb = (_?: Error) => {}): Promise<any> {
  return post('/me/settings', settings, cb)
}
